import React, { Component } from "react";
import { HashRouter, Route, Switch } from "react-router-dom";
import { connect } from "react-redux";
import "./App.scss";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { GetProfilePost } from "./Redux/actions/";
import { PrivateRoute } from "./components/Routes/PrivateRoute";
const loading = () => (
  <div className="animated fadeIn pt-3 text-center">Loading...</div>
);

// Containers
const DefaultLayout = React.lazy(() => import("./containers/DefaultLayout"));

// Pages
const Login = React.lazy(() => import("./views/Public/Login"));
const Register = React.lazy(() => import("./views/Public/Register"));
const Page404 = React.lazy(() => import("./views/Error/Page404"));
const Page500 = React.lazy(() => import("./views/Error/Page500"));

class App extends Component {
  render() {
    return (
      <HashRouter>
        <React.Suspense fallback={loading()}>
          <Switch>
            <Route
              exact
              path="/login"
              name="Login Page"
              render={props => <Login {...props} />}
            />
            <Route
              path="/register/:badgeNo"
              name="Register Page"
              render={props => <Register {...props} />}
            />
            <Route
              exact
              path="/404"
              name="Page 404"
              render={props => <Page404 {...props} />}
            />
            <Route
              exact
              path="/500"
              name="Page 500"
              render={props => <Page500 {...props} />}
            />
            <PrivateRoute
              path="/"
              name="Home"
              render={props => <DefaultLayout {...props} />}
            />
          </Switch>
        </React.Suspense>
      </HashRouter>
    );
  }
}
const mapStateToProps = state => {
  return {
    currentUser: state.auth.currentUser
  };
};
export default connect(
  mapStateToProps,
  { getProfilePost: GetProfilePost }
)(App);
